"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var elegir = function elegir() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length > 0) {
    if (args[0] === true) {
      return args[1];
    }

    return elegir.apply(undefined, _toConsumableArray(args.slice(2)));
  }
};

exports.default = elegir;


//////////////////
// WEBPACK FOOTER
// ../node_modules/elegir/dist/index.js
// module id = 245
// module chunks = 0